import React from "react";
import {Container} from "@mui/material";
import {DashboardHeader} from "../../../../UIKit/DashboardHeader";
import {useUiContext} from "../../../../UIProvider";
import {MenstrualCyclesTable} from "../components/table";

export const MenstrualCyclesView = () => {
    const { t } = useUiContext();

    return (
        <Container maxWidth="xl">
            <DashboardHeader title={t('menstrualCycles.menstrualCycles')} />
            <MenstrualCyclesTable />
        </Container>
    )
}